import React from 'react';
    import { motion } from 'framer-motion';

    const HeartbeatLine = () => {
      return (
        <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-20">
          <svg
            className="w-full h-full"
            viewBox="0 0 1200 200"
            preserveAspectRatio="none"
          >
            <defs>
              <linearGradient id="orangeGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#F7931A" stopOpacity="0" />
                <stop offset="20%" stopColor="#F7931A" stopOpacity="0.3" />
                <stop offset="80%" stopColor="#F7931A" stopOpacity="0.3" />
                <stop offset="100%" stopColor="#F7931A" stopOpacity="0" />
              </linearGradient>
            </defs>
            
            <motion.path
              d="M 0,100 L 200,100 L 250,50 L 300,150 L 350,100 L 550,100 L 750,100 L 800,40 L 850,160 L 900,100 L 1200,100"
              stroke="url(#orangeGradient)"
              strokeWidth="2"
              fill="none"
              initial={{ pathLength: 0 }}
              animate={{ pathLength: 1 }}
              transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
            />
            
            <motion.path
              d="M 0,100 L 200,100 L 250,50 L 300,150 L 350,100 L 550,100 L 750,100 L 800,40 L 850,160 L 900,100 L 1200,100"
              stroke="#F7931A"
              strokeWidth="1"
              fill="none"
              opacity={0.5}
              initial={{ pathLength: 0 }}
              animate={{ pathLength: 1 }}
              transition={{ duration: 2, repeat: Infinity, ease: "linear", delay: 0.1 }}
            />
          </svg>
        </div>
      );
    };

    export default HeartbeatLine;